import { Pipe, PipeTransform } from '@angular/core';

type Value = string | null | undefined;

@Pipe({
  name: 'uuid',
  pure: true,
})
export class UuidPipe implements PipeTransform {
  private readonly length = 8;

  transform(value: Value): Value {
    return value?.replace(/\W/gi, '')?.slice(0, this.length);
  }
}
